module.exports = __webpack_public_path__ + "img/img5.82038e45.png";